// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import * as routes from "../../config/routes";
import { ApplicationSessionContext } from "../ApplicationSession";
import { ApplicationLoader } from "../ApplicationLoader";
import { UserService } from "../../entities/User";
import { Navigate, useLocation } from "../../services/router";
import { jsx as _jsx } from "react/jsx-runtime";
export const ApplicationRoute = props => {
  const {
    component: Component,
    authenticate
  } = props;
  const {
    user
  } = React.useContext(ApplicationSessionContext);
  const location = useLocation();
  return React.useMemo(() => !authenticate || UserService.isValid(user) ? /*#__PURE__*/_jsx(React.Suspense, {
    fallback: /*#__PURE__*/_jsx(ApplicationLoader, {
      type: "screen"
    }),
    children: /*#__PURE__*/_jsx(Component, {})
  }) : /*#__PURE__*/_jsx(Navigate, {
    to: {
      pathname: routes.authenticationLogin,
      state: {
        from: location,
        disconnected: true
      }
    }
  }), [user, location, authenticate]);
};